import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import _ from 'lodash';

import styles from './feedItemStyles';

import ActionsContainer from 'buyside/components/presentation/Feed/Actions/ActionsContainer';

class FeedItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: false, startTimestamp: null, error: null };
    this.generateClickHandler = this.generateClickHandler.bind(this);
  }

  onChange(isVisible, location, source = 'viewport_exit') {
    if (!this.state.visible && isVisible) {
      this.state.visible = true;
      this.state.startTimestamp = new Date().getTime();
    } else if (this.state.visible && !isVisible) {
      this.state.endTimestamp = new Date().getTime();
      const interval = this.state.endTimestamp - this.state.startTimestamp;

      if (interval < 1000) {
        return;
      }

      this.state.visible = false;
      this.props
        .handleImpression({
          eventId: this.props.event.id,
          elapsedTime: interval,
          index: this.props.index,
          sessionId: this.props.currentUser.sessionId,
          source: source
        })
        .then(
          () => this.setState({ error: null }),
          error => this.setState({ error: error })
        );
    }
  }

  generateClickHandler(source) {
    if (!source) return;
    return () => {
      this.onChange(false, 'placeholder', source);
    };
  }

  render() {
    const {
      config,
      createdAt,
      currentUser,
      event,
      feedType,
      forMentionedEntity,
      id,
      isPublic,
      recommendations
    } = this.props;
    if (this.state.error) throw this.state.error;
    if (!config) return null;
    const { eventObject, verb } = event;
    const { actions, component, clickHandlerName } = config;

    const FeedItemComponent = component;

    let hideLikes;
    if (eventObject && _.has(eventObject.commentObject)) {
      hideLikes = eventObject.commentObject.__typename === 'EmployerProfile';
    }

    // prevents an edge case, leaving in for now (returning null here throws an error with CSSTransition)
    if (verb === 'PUBLISH_FUND_PROFILE_UPDATE' && (!eventObject || !eventObject.fundProfile)) {
      return <span />;
    }
    if (verb === 'CORPORATE_ACTION' && !eventObject.parentActionPeriodReturn) return <span />;

    const eventObjectMap = {};
    if (config.eventObjectName) {
      eventObjectMap[config.eventObjectName] = eventObject;
    }

    if (
      ['PUBLISH_ALLOCATOR_PROFILE', 'PUBLISH_FUND_PROFILE'].includes(verb) &&
      recommendations.edges
    ) {
      recommendations.edges.forEach(edge => {
        if (edge.node.fundProfile) {
          if (edge.node.fundProfile.id === eventObject.id) {
            eventObjectMap['recommendation'] = edge.node;
            eventObjectMap['recommendedFundProfile'] = edge.node.fundProfile;
          }
        } else if (edge.node.allocatorProfile) {
          if (edge.node.allocatorProfile.id === eventObject.id) {
            eventObjectMap['recommendation'] = edge.node;
            eventObjectMap['recommendedAllocatorProfile'] = edge.node.allocatorProfile;
          }
        }
      });
    }
    return (
      <div className={styles.feedItem}>
        <VisibilitySensor
          minTopValue={500}
          onChange={this.onChange.bind(this)}
          partialVisibility
          scrollCheck
        >
          <>
            <div style={{ display: 'none' }}>FeedItem: {id}</div>
            <FeedItemComponent
              {...eventObjectMap}
              createdAt={createdAt}
              currentUser={currentUser}
              eventVerb={verb}
              feedItemId={id}
              handleClick={this.generateClickHandler(clickHandlerName)}
              isPublic={isPublic}
              narrow
              shouldHighlightMention={forMentionedEntity && feedType === 'Entity'}
            />
            {actions && currentUser && (
              <ActionsContainer
                allowAnonymousComment={currentUser.canCommentAnonymously}
                currentUserHasLiked={event.currentUserHasLiked}
                currentUserId={currentUser.id}
                eventId={event.id}
                eventObject={eventObject}
                eventVerb={verb}
                feedItemId={id}
                hideLikes={hideLikes}
                isAllocator={currentUser.isAllocator}
                isRetail={currentUser.isRetail}
                likeCount={event.likeCount}
                profileImageUrl={currentUser.profileImageUrl}
              />
            )}
          </>
        </VisibilitySensor>
      </div>
    );
  }
}

export default FeedItem;
